/* LMM compatibility cleanup. Predictive search is handled centrally by lmm-search-intent-engine.js. */
(function () {
  'use strict';
  if (window.LMMTubeHierarchyCleanup) return;
  window.LMMTubeHierarchyCleanup = true;

  function norm(value) {
    return String(value || '').toLowerCase()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
      .replace(/[^a-z0-9\s]/g,' ').replace(/\s+/g,' ').trim();
  }

  function clean(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.td-count,.lmm-intent-panel__footer,.lmm-intent-panel__primary').forEach(function (element) {
      element.remove();
    });
    scope.querySelectorAll('.lmm-cattree details.cat-grp').forEach(function (details) {
      var parent = details.querySelector(':scope > summary a[href*="/collections/led-roehren"]');
      var list = details.querySelector(':scope > .cat-kids');
      if (!parent || !list) return;
      Array.from(list.children).forEach(function (item) {
        var link = item.querySelector('a[href*="/collections/led-roehren"]');
        if (link && norm(link.textContent).indexOf('uebersicht') !== -1) item.remove();
      });
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; clean(document); });
  }

  if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', schedule, { once: true }) : schedule();
})();
